import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoSpinner } from "@redotech/redo-web/arbiter-components/loading/redo-spinner";
import { memo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { RedoMarketplaceRpcClientContext } from "@redotech/redo-marketplace-app-common/rpc-client";
import { Flex } from "@redotech/redo-web/flex";
import { useCart } from "../../context";
import { CheckoutCancel } from "./checkout-cancel";

export const CheckoutCancelContainer = memo(function CheckoutCancelContainer() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const marketplaceRpcClient = useRequiredContext(
    RedoMarketplaceRpcClientContext,
  );
  const { refreshCart } = useCart();

  const marketplaceOrderId = searchParams.get("marketplaceOrderId");

  const cancelResult = useLoad(async () => {
    if (marketplaceOrderId) {
      await marketplaceRpcClient.cancelCheckout({ marketplaceOrderId });
      return;
    }

    throw new Error("No cart ID or marketplace order ID found in URL");
  }, [marketplaceOrderId, marketplaceRpcClient, refreshCart]);

  const handleRetryCheckout = () => {
    navigate("/checkout");
  };

  const handleContinueShopping = () => {
    navigate("/");
  };

  if (cancelResult.pending) {
    return (
      <Flex align="center" content="center" fontSize="xl" height="half-screen">
        <RedoSpinner />
      </Flex>
    );
  }

  return (
    <CheckoutCancel
      onContinueShopping={handleContinueShopping}
      onRetryCheckout={handleRetryCheckout}
    />
  );
});
